package dev.lingvo.shared.screenshots.templates

import dev.lingvo.shared.screenshots.doc.Board
import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.shared.screenshots.doc.Page
import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.doc.TemplateId
import dev.lingvo.shared.screenshots.doc.TypeRole

/** Stable slot keys bind template content to the existing screenshot plan. */
data class TemplateSlot(val slotKey: String, val accent: String?)

/** Picker categories remain independent of template display names. */
enum class TemplateCategory { LAYOUT, MINIMAL, BOLD, DARK, PLAYFUL }

/** Templates build ordinary editable pages rather than a second document format. */
interface Template {
    /** Stable identity survives display-name changes. */
    val id: TemplateId
    /** Human-readable picker label. */
    val displayName: String
    /** Supports filtering without coupling the picker to individual templates. */
    val categories: Set<TemplateCategory>
    /** Seeds palette derivation before a brand colour is chosen. */
    val defaultHue: Double
    /** Supplies role-specific typography before script fallback. */
    val families: Map<TypeRole, String>
    /** Allows the renderer to mirror only templates designed for RTL. */
    val mirrorRtl: Boolean
    /** Creates editable pages for the selected plan slots and store canvas. */
    fun build(brand: BrandKit, board: Board, slots: List<TemplateSlot>, palette: Palette): List<Page>
}

/** A single ordered catalog keeps launch choices consistent across screens. */
interface TemplateCatalog {
    /** The three launch layouts precede the twelve templates. */
    val all: List<Template>
    /** IDs are layout-caption-top, layout-caption-bottom and layout-caption-over. */
    val launchLayouts: List<Template>
    /** Unknown IDs can fall back safely when loading an older document. */
    fun byId(id: TemplateId): Template?
}
